export const isVoid = <T>(value: T | undefined | null): value is undefined | null => {
  if (value === null || value === undefined) return true;

  if (typeof value === "string" && value.trim() === "") return true;

  if (Array.isArray(value) && value.length === 0) return true;

  if (typeof value === "object" && Object.keys(value).length === 0) return true;

  return false;
};

export const isNotVoid = <T>(
  value: T,
): value is Exclude<T, null | undefined | "" | [] | NonNullable<unknown>> => {
  return !isVoid(value);
};
